import Breadcrumb from "components/Common/Breadcrumb"
import QwikForm from "components/form/QwikForm"
import QwikInput from "components/form/QwikInput"
import React from "react"
import { Col, Container, Row } from "reactstrap"
import { useCreateCostingMutation } from "store/features/costing/costingManagementApi"
import { toast } from "sonner"
import { useNavigate } from "react-router-dom"

const AddCosting = () => {
  const [createCosting, { isLoading }] = useCreateCostingMutation()
  const navigate = useNavigate()

  const handleSubmit = async data => {
    try {
      await createCosting(data).unwrap()

      toast.success("Costing added successfully!")

      // Redirect to /costings after 2 seconds
      setTimeout(() => {
        navigate("/all-costings")
      }, 2000)
    } catch (error) {
      console.error("Costing creation error:", error)
      toast.error("Failed to add costing. Please try again.")
    }
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumb title="Costings" breadcrumbItem="Add Costing" />
        <Row>
          <QwikForm onSubmit={handleSubmit}>
            <Col className="col-12">
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="project_name"
                      label="Project Name"
                      placeholder="Enter project name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="item_name"
                      label="Item Name"
                      placeholder="Enter item name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="amount"
                      label="Amount"
                      placeholder="Enter amount"
                      type="number"
                      step="0.01"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="notes"
                      label="Notes"
                      placeholder="Enter any notes about this costing"
                      type="textarea"
                      className="form-control"
                      rows="4"
                    />
                  </div>
                </Col>
                <div className="col-sm-6 text-start">
                  <button
                    className="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Adding..." : "Add Costing"}
                  </button>
                </div>
              </Row>
            </Col>
          </QwikForm>
        </Row>
      </Container>
    </div>
  )
}

export default AddCosting
